<template>
  <div>
    <Header></Header>
    <Banner></Banner>
    <div class="about" id="about">
      <div class="item" v-for="(item, index) in $t('lang.about')" :key="index">
        <div>
          <div class="icon" :class="'a'+(index + 1)"></div>
          <h3 class="title">{{ item.title }}</h3>
          <p class="text f12">{{ item.text }}</p>
        </div>
        <button class="btn learn" @click="goto(item.url)">{{ item.btn }}</button>
      </div>
    </div>
    <div class="bar"></div>
    <div class="rapid">
      <div class="left-shadow" :class="show?'show':''"></div>
      <div class="con">
        <h3 class="title">{{ $t('lang.rapid.title') }}</h3>
        <div class="r-img">
          <img :src="rImg" />
        </div>
        <button class="btn" @click="goto('what')">{{ $t('lang.rapid.btn') }}</button>
      </div>
      <div class="right-shadow" :class="show?'show':''"></div>
    </div>
    <div class="video">
      <iframe
        class="iframe"
        :src="link&&link.vedio_embed"
        frameborder="0"
        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
      ></iframe>
      <!-- <video :src="link&&link.vedio" controls="controls"></video> -->
    </div>
    <div class="operate">
      <div class="con">
        <h5 class="title">{{ $t('lang.metaverse') }}</h5>
        <div class="item metaverse">
          <p class="hide">{{ $t('lang.metaText') }}</p>
          <div class="op-btn">
            <button class="btn" @click="gotoLink('whitepaper')">{{ $t('lang.metaBtn') }}</button>
          </div>
        </div>
        <h5 class="title">{{ $t('lang.community') }}</h5>
        <div class="item community">
          <p class="hide">{{ $t('lang.comText') }}</p>
          <div class="op-btn">
            <div class="mail">
              <input type="text" ref="emailInput" :placeholder="$t('lang.mailPlace')" />
              <button
                class="btn stay"
                @click="onEmailClick"
              >{{ joinMailList?$t('lang.comBtnJoin'):$t('lang.comBtn') }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Banner from "./components/Banner";
import Header from "@/components/Header";
import { home } from "../../common/link.js";
import { submitEmail } from "../../util/http.js";
export default {
  name: "Home",
  components: {
    Header,
    Banner,
  },
  data() {
    return {
      rImg: "",
      link: home,
      joinMailList: false,
      show: false,
      imgInv: 0,
    };
  },
  created() {
    this.rImg = require("../../assets/images/rapid-en-US.png");
    clearInterval(this.imgInv);
    this.imgInv = setInterval(() => {
      let lang = this.$i18n.locale;
      //console.log(lang);
      if (lang == "zh-CN") {
        this.rImg = require("../../assets/images/rapid-zh-CN.png");
      } else {
        this.rImg = require("../../assets/images/rapid-en-US.png");
      }
    }, 1000);

    localStorage.setItem("url", "home");
  },
  mounted() {
    window.scrollTo(0, 0);
    window.addEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      let offsetTop = document.querySelector("#about").offsetTop;
      let scrollTop = document.documentElement.scrollTop;
      if (scrollTop >= offsetTop) {
        this.show = true;
      }
    },
    goto(url) {
      switch (url) {
        case "home":
          this.$router.push("/");
          break;
        case "what":
          if (this.$route.name == "BuildWhat") {
            this.$emit("scroll", "");
          } else {
            this.$router.push({ name: "BuildWhat", params: { id: "what" } });
          }
          break;
        case "development":
          this.$router.push({ name: "BuildDevelopment" });
          break;
        case "connect":
          if (this.$route.name == "Connect") {
            this.$emit("scroll", "");
          } else {
            this.$router.push({ name: "Connect", params: { id: "connect" } });
          }
          break;
        case "ambassador":
          if (this.$route.name == "Connect") {
            this.$emit("scroll", "ambassador");
          } else {
            this.$router.push({
              name: "Connect",
              params: { id: "ambassador" },
            });
          }
          break;
        case "exchanges":
          if (this.$route.name == "Connect") {
            this.$emit("scroll", "exchanges");
          } else {
            this.$router.push({ name: "Connect", params: { id: "exchanges" } });
          }
          break;
        case "institute":
          this.$router.push({ name: "Institute" });
          break;
        case "helix":
          if (this.$route.name == "BuildWhat") {
            this.$emit("scroll", "helix");
          } else {
            this.$router.push({ name: "BuildWhat", params: { id: "helix" } });
          }

          break;
        default:
          break;
      }
    },
    gotoLink(url) {
      if (!url) {
        this.$message.info({
          message: this.$t("lang.comingsoon"),
          duration: 800,
        });
        return;
      }
      window.open(this.link[url], "_blank");
    },
    async onEmailClick() {
      let email = this.$refs.emailInput.value;
      let rex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (!email || !rex.test(email)) {
        return;
      }
      let result = await submitEmail(email);
      //console.log('code:' + result.code)
      if (result.code == 0 || result.code == 2) {
        this.joinMailList = true;
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~css/mixins.styl';
@import '~css/varibles.styl';

.about {
  layout();
  display: flex;
  flex-direction: row;
  padding: 0.6rem 0;

  .item {
    flex: 1;
    padding: 0 6%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    &:first-child {
      border-right: 1px solid #e5e5e5;
    }

    &:last-child {
      border-left: 1px solid #e5e5e5;
    }

    .icon {
      width: 1.12rem;
      height: 0.97rem;
      margin: 0.2rem 0;

      &.a1 {
        background: url('../../assets/images/about1.png') left center no-repeat;
        background-size: auto 100%;
      }

      &.a2 {
        background: url('../../assets/images/about2.png') left center no-repeat;
        background-size: 100% auto;
      }

      &.a3 {
        background: url('../../assets/images/about3.png') left center no-repeat;
        background-size: auto 100%;
      }
    }

    .title {
      font-size: 0.4rem;
      color: $dark;
      margin-bottom: 0.2rem;
      font-family: HelveticaLight;
    }

    .text {
      font-size: 0.18rem;
      color: $light;
      line-height: 0.28rem;
      margin-bottom: 0.2rem;
      font-family: HelveticaLight;
    }

    .btn {
      width: 2.3rem;
      height: 0.46rem;
    }
  }
}

.bar {
  width: 100%;
  height: 0.2rem;
  background: #044b9b;
}

.rapid {
  position: relative;

  .left-shadow, .right-shadow {
    position: absolute;
    top: 0;
    width: 1rem;
    height: 100%;
    -webkit-transition: all 1s ease-in;
    -moz-transition: all 1s ease-in;
    transition: all 1s ease-in;
  }

  .left-shadow {
    left: -1rem;
    background: url('../../assets/images/left-shadow.png') left center no-repeat;
    background-size: 100% auto;

    &.show {
      left: 0;
    }
  }

  .right-shadow {
    right: -1rem;
    background: url('../../assets/images/right-shadow.png') left center no-repeat;
    background-size: 100% auto;

    &.show {
      right: 0;
    }
  }

  .con {
    layout();
    padding: 0.6rem 0;
    text-align: center;
  }

  .title {
    font-size: 0.4rem;
    color: #000;
    margin-bottom: 0.3rem;
  }

  .r-img {
    width: 11.81rem;
    height: 7.96rem;
    margin: 0 auto;

    img {
      width: auto;
      max-width: 100%;
    }
  }

  .btn {
    width: 5rem;
    height: 0.6rem;
    margin-top: 0.48rem;
  }
}

.video {
  center();
  background: url('../../assets/images/videobg.jpg') center center no-repeat;
  background-size: 100% auto;

  .iframe {
    width: 8.5rem;
    height: 5rem;
    margin: 0.5rem auto 1rem;
    background: url('../../assets/images/video.png') center center no-repeat #dbdbdb;
  }
}

.operate {
  background-color: #fafafa;

  .title {
    font-size: 0.34rem;
    color: #444;
    padding: 0 0 0.2rem;
  }

  .item {
    height: 2rem;
    background: #442972;
    center();
    justify-content: space-between;
    padding: 0 0.6rem;

    &.metaverse {
      background: url('../../assets/images/metaverse.png') center center no-repeat;
      background-size: 100% auto;
      margin-bottom: 0.6rem;
    }

    &.community {
      background: url('../../assets/images/community.png') center center no-repeat;
      background-size: 100% auto;
    }

    p {
      font-size: 0.18rem;
      color: $white;
      line-height: 0.3rem;
      flex: 1;
      font-family: HelveticaLight;
    }

    .op-btn {
      flex: 1;
      text-align: right;
    }

    .btn {
      width: 3.15rem;
      height: 0.6rem;
      background-color: #0064d6;
      color: $white;
    }

    .mail {
      width: 5rem;
      center();
      justify-content: space-between;
      float: right;
      border-radius: 10px;
      border: 1px solid #0064d6;
      background-color: rgba(0, 15, 52, 0.45);

      input {
        border: none;
        background: transparent;
        text-align: center;
        color: $white;
        width: 3rem;
        font-size: 0.18rem;

        &::-webkit-input-placeholder {
          font-style: italic;
          color: rgba(255, 255, 255, 0.9);
        }

        &:-moz-placeholder {
          font-style: italic;
          color: rgba(255, 255, 255, 0.9);
        }

        &::-moz-placeholder {
          font-style: italic;
          color: rgba(255, 255, 255, 0.9);
        }

        &:-ms-input-placeholder {
          font-style: italic;
          color: rgba(255, 255, 255, 0.9);
        }
      }

      input:focus::-webkit-input-placeholder {
        color: transparent;
      }

      input:focus:-moz-placeholder {
        color: transparent;
      }

      input:focus::-moz-placeholder {
        color: transparent;
      }

      input:focus:-ms-input-placeholder {
        color: transparent;
      }

      .btn {
        width: 2rem;
      }
    }
  }
}

@media screen and (max-width: 750px) {
  .about {
    display: inherit;

    .item {
      padding: 10px;
      border-bottom: 1px solid #e5e5e5;

      .icon {
        width: 80px;
        height: 64px;
        margin: 10px auto;
      }

      .title {
        text-align: center;
      }

      .btn {
        display: block;
        min-width: auto;
        width: 120px;
        margin: 0 auto;
      }

      &:first-child {
        border-right: none;
      }

      &:last-child {
        border-left: none;
      }
    }
  }

  .rapid {
    .btn {
      width: 200px;
    }
  }

  .operate {
    .item {
      .op-btn {
        text-align: center;
      }

      .btn {
        width: 180px;
      }

      .mail {
        width: 260px;

        input {
          font-size: 0.4rem;
          width: 140px;
        }

        .btn {
          min-width: auto;
          width: 100px;
        }
      }
    }
  }

  .video {
    .iframe {
      width: 12rem;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/home/Home.vue